import { FC, useEffect, useState } from 'react';

import { NavigationItem } from '@telialt/models/src/Navigation';
import { useUserDataQueryBase } from '@telialt/utils/src/SSO/useUserData';

import { MobileMenuItemComponentSkeleton } from './MobileMenuItemComponentSkeleton';
import { MobileMenuItemComponentStrong } from './MobileMenuItemComponentStrong';

type Props = {
    item: NavigationItem;
    menuLevel: number;
};

export const MobileMenuItemComponentMobility: FC<Props> = ({ item, menuLevel }) => {
    const [isMounted, setIsMounted] = useState(false);
    const { userData, isLoadingUserData } = useUserDataQueryBase({
        isEnabled: isMounted,
    });

    useEffect(() => {
        setIsMounted(true);
    }, []);

    if (isLoadingUserData) {
        return <MobileMenuItemComponentSkeleton />;
    }

    if (!userData?.isMobility && !userData?.isStrong) {
        return null;
    }

    return <MobileMenuItemComponentStrong item={item} menuLevel={menuLevel} />;
};
